import React from 'react';
import { ElementItem } from '../../../utils/element.type';
import Image from 'next/image';
import BottomLine from '../../elements/bottomLine';

interface CardItemProps {
  category: string[]
  imageName: string
}

interface ElementProps {
    activeItems: ElementItem[];
    setActiveItems: React.Dispatch<React.SetStateAction<ElementItem[]>>;
}

export default function Card({ activeItems, setActiveItems }: ElementProps) {
  const CardItem = ({ category, imageName }: CardItemProps) => {
    const imagePath = `/wikicards/${category}/${imageName}`;

    return (
      <div className='relative w-[150px] h-[220px] sm:w-[250px] sm:h-[350px] animate-fade-in hover:drop-shadow-[0px_0px_10px_white] transform transition-transform duration-300 ease-in-out hover:scale-110 cursor-pointer'>
        <Image
          className='object-fill'
          src={imagePath}
          alt={`${category} card`}
          loading='lazy'
          fill
        />
      </div>
    );
  };

  const getActiveElementName = () => {
    return activeItems.filter((item) => item.active).map((item) => item.name);
  };

    const toggleItem = (index: number) => {
        setActiveItems(
            activeItems.map((item, i) => ({
                ...item,
                active: i === index
            }))
        );
    };


    return (
      <section className='relative flex flex-col items-center justify-center lg:-mt-20 -mt-14 z-10'>
        <Image
          className='object-cover sm:object-fill'
          src='/background/wiki/card.webp'
          alt='background card image'
          fill
          priority
      />
        <div className='relative w-full lg:mt-20 mt-10 lg:mb-20 px-4'>
          <div className='text-white relative flex flex-col items-center justify-center'>
            <div className='relative flex items-center justify-between mt-20 lg:mt-10 3xl:w-[1378px] xl:w-[1096px] lg:w-[814px] sm:w-[532px] w-[332px]'>
              <div>
                {activeItems.map((item, index) => (
                  <div key={index}>
                    {item.active && <p className='text-[24px] lg:text-[48px] text-white font-georgia font-[700] leading-tight max-w-screen-xl drop-shadow-[0px_3px_2px_black]'>{item.title}</p>}
                  </div>
                      ))}
              </div>
              <div>
                <div className='flex flex-row gap-2 w-full justify-center'>
                  {activeItems.map((item, index) => (
                    <div
                        key={index}
                         className='relative w-10 h-10 lg:w-14 lg:h-14 animate-fade-in transform transition-transform duration-300 ease-in-out hover:scale-110 cursor-pointer hover:drop-shadow-[0px_0px_5px_white]'
                         onClick={() => {
                         toggleItem(index);
                     }}
                   >
                      <Image
                            src={`/elements/${item.image}.webp`}
                            alt='Mana image'
                            fill
                            priority
                        />
                      {!item.active && (
                        <div className='absolute inset-0 bg-black bg-opacity-60 rounded-full'></div>
                        )}
                    </div>

                  ))}
                </div>
              </div>
            </div>
            <div className='mt-4 mb-4 grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 3xl:grid-cols-5 gap-8'>
              {Array.from({ length: 33 }, (_, i) => (
                <CardItem
                key={i}
                category={getActiveElementName()}
                imageName={`${i}.webp`}
              />
            ))}
            </div>
          </div>
        </div>
        <BottomLine bottomLine={'yellow'} />
      </section>
    );
}
